import get from 'lodash/get';
import { viewportActions, updateQueue, updateTask, setProjectState } from '@starflow/app/store';
import { findNextTaskPosition } from '@starflow/app/modules/generator/helpers';
import { enterDerivativeFromUnit } from '../../derivative';

// 流节点的能力描述
// 1. 包含输入参数和输出参数，并且输入和输出的端口都是动态的
// 2. 包含执行函数，用于执行功能模块的功能
// 3. 可以注册新的画布元素
// 4. 可以在应用的各个预设位置渲染自定义的UI组件
// 5. 可以暴露出一些方法供其他功能模块调用
// 6. 可以在应用初始化时进行一些初始化操作
// 7. 有一些生命周期函数，用于在特定的时机执行一些操作

const baseInputPorts = [];

const baseOutputPorts = [
  {
    name: 'items',
    type: 'images',
  },
];

export default {
  type: 'workflow',

  title: '封装工作流',

  isFlowUnit: true, // 是否是流程单元

  defaultData: (data) => {
    return {};
  },

  extractProjectData: (data) => {
    // 旧数据兼容
    return data.workflow ? { ...data, ...data.workflow } : data;
  },

  methods: {},

  // 获取输入端口
  getInputPorts(data) {
    return data.nodes.reduce((acc, node, nodeIndex) => {
      const { fields } = node;

      fields.forEach((field, fieldIndex) => {
        if (field.type === 'image') {
          acc.push({
            name: `nodes[${nodeIndex}].fields[${fieldIndex}].value`,
            type: 'image',
            label: node.title,
          });
        } else if (field.type === 'mask') {
          acc.push({
            name: `nodes[${nodeIndex}].fields[${fieldIndex}].value.sourceImage`,
            type: 'image',
            label: node.title,
          });
        }
      });

      return acc;
    }, []);
  },

  // 获取输出端口
  getOutputPorts(data) {
    return baseOutputPorts;
  },

  // 设置输入
  applyInput(name, value, data) {
    return { ...data, [name]: value };
  },

  // 获取输出
  getInputs(data, name) {
    if (!name) {
      const inputPorts = this.getInputPorts(data);

      return inputPorts.map((port) => ({
        name: port.name,
        type: port.type,
        value: get(data, port.name),
        label: port.label,
      }));
    }

    return get(data, name);
  },

  // 获取输出
  getOutput(name, data) {
    return name ? data.result[name] : data.result;
  },

  onDataUpdate(data, app) {},

  onFocus(data, app) {},

  // 主生成器任务在插入到队列之后执行的操作
  onQueue({ data }) {
    const width = 1024;
    const height = 1024;
    const { x, y } = findNextTaskPosition();

    updateQueue(data.id, { x, y, width, height });
    viewportActions.locateRect({ x, y, width, height }, { animate: true });
  },

  onBeforeExecute(data, app) {},

  onAfterExecute(data, app) {},

  onNodeClick(data) {
    // 如果是流上的生成器，则进入画布
    if (data.flowId) {
      enterDerivativeFromUnit('workflow', data);
    } else {
      setProjectState({
        selection: [],
        currentElementTool: null,
        currentNodeId: data.id,
      });
    }
  },

  async resume({ data, app }) {
    await app.modules.generator.methods.resumeGeneration(data);
  },

  // 主生成器任务的具体执行函数，该任务执行完则会执行下一个任务
  async execute({ data, app }) {
    const width = 1024;
    const height = 1024;

    const taskPositionInfo = {
      x: data.x,
      y: data.y,
      width,
      height,
    };

    if (typeof data.x === 'undefined' || typeof data.y === 'undefined') {
      // 执行之前，在画布上寻找合适的显示生成器
      const { x, y } = findNextTaskPosition();

      taskPositionInfo.x = x;
      taskPositionInfo.y = y;

      updateTask(data.id, taskPositionInfo);
      viewportActions.locateRect({ x, y, width, height }, { animate: true });
    }

    await app.modules.generator.methods.submitGeneration(data);
  },
};
